import React from "react"
import ExternalFeatureFlagProvider from "contexts/ExternalFeatureFlag/Provider"
import { type DynamicYieldExperience } from "hooks/useDynamicYieldExperience"
import WishListProvider from "contexts/WishList/Provider"
import type { FeatureFlagData } from "hooks/useDynamicYieldExperience/types"
import { filterExperiencesByGroup } from "lib/helpers"
import SignInProvider from "accounts/contexts/SignIn/Provider"

interface GlobalProvidersProps {
  children: React.ReactNode
  serverSideDynamicYieldProps: DynamicYieldExperience[]
}

const GlobalPageProviders = ({
  children,
  serverSideDynamicYieldProps
}: GlobalProvidersProps) => {
  const featureFlagProviderProps = filterExperiencesByGroup({
    experiences: serverSideDynamicYieldProps,
    groups: [`FeatureFlags`]
  }) as FeatureFlagData[]

  return (
    <ExternalFeatureFlagProvider
      serverSideDynamicYieldProps={featureFlagProviderProps ?? undefined}
    >
      <SignInProvider>
        <WishListProvider>{children}</WishListProvider>
      </SignInProvider>
    </ExternalFeatureFlagProvider>
  )
}

export default GlobalPageProviders
